import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  hoverable?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
}

const CardContainer = styled(motion.div)<CardProps>`
  background: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borderRadius.lg};
  border: 1px solid ${props => props.theme.colors.border};
  box-shadow: none;
  overflow: hidden;
  transition:
    border-color ${props => props.theme.animation.duration.normal} ${props => props.theme.animation.easing.easeOut},
    box-shadow ${props => props.theme.animation.duration.normal} ${props => props.theme.animation.easing.easeOut};

  ${props => props.hoverable && `
    cursor: pointer;

    &:hover {
      border-color: ${props.theme.colors.neutral[300]};
      box-shadow: ${props.theme.shadows.md};
    }
  `}

  ${props => props.padding === 'sm' && `
    padding: ${props.theme.spacing[4]};
  `}

  ${props => props.padding === 'md' && `
    padding: ${props.theme.spacing[6]};
  `}

  ${props => props.padding === 'lg' && `
    padding: ${props.theme.spacing[8]};
  `}
`;

const Card: React.FC<CardProps> = ({
  children,
  hoverable = false,
  padding = 'md',
  className,
  ...props
}) => {
  return (
    <CardContainer
      hoverable={hoverable}
      padding={padding}
      className={className}
      initial={hoverable ? { y: 0 } : undefined}
      whileHover={hoverable ? { y: -4 } : undefined}
      {...props}
    >
      {children}
    </CardContainer>
  );
};

export default Card;